import DeviceManager from 'tm3-pay/utils/device-manager';
import React from 'react';
// TM3 Pay
const Settings = React.lazy(() => import('tm3-pay/modules/settings'));
const CardType = React.lazy(() => import('tm3-pay/modules/finances/card-type'));
export default {
  '2f27420c-434a-4627-af97-aedee9c02dff': {
    control: Settings,
    description: 'TM3 Pay Settings'
  },
  'dfcd08d9-06e5-478a-a293-ad746e4a2ef9': {
    control: DeviceManager,
    description: 'TM3 Pay Device Manager'
  },
  'f85df827-f927-4bd2-a072-c61918246bdd': {
    control: CardType,
    description: 'TM3 Pay Card Types'
  }
};
